"use client";

import { Button, ButtonLink } from "@/components/ui/Button/Button";

import Link from "next/link";
import Logo from "@/components/ui/Logo";
import React from "react";
import clsx from "clsx";
import { event } from "@/helpers/gtag";
import styles from "./Header.module.css";
import { useLocale } from "next-intl";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";

type HeaderProps = React.ComponentProps<"header"> & {
  theme: "light" | "dark";
};

const DesktopHeader = ({ className, ...delegated }: HeaderProps) => {
  const locale = useLocale();
  const pathname = usePathname();
  const t = useTranslations("header");

  const otherLocale = locale === "en" ? "ar" : "en";
  const switchLabel = locale === "en" ? "عربي" : "English";

  // Extract the path without the locale to keep the same page when switching languages
  const pathnameWithoutLocale = pathname.replace(`/${locale}`, '');
  // Use the current path or root if we're already at root
  const targetPath = pathnameWithoutLocale || '/';
  
  return (
    <header
      className={clsx(
        styles.wrapper,
        className
        // locale === "ar" ? styles.ar : null
      )}
      {...delegated}
    >
      <Logo isFooter={false} />

      <nav className={styles.nav}>
        <Link href={`/${locale}/mobile-app`} locale={false}>
          {t("boursaApp")}
        </Link>

        <Link href={`/${locale}/competition`} locale={false}>
          {t("competition")}
        </Link>

        <Link href={`/${locale}/about-us`} locale={false}>
          {t("about")}
        </Link>

        <Link href={`/${locale}/blog`} locale={false}>
          {t("blog")}
        </Link>
      </nav>

      <div className={styles.actions}>
        <ButtonLink
          href="https://store.boursa.io/5O4u/web"
          isExternal
          className={styles.action}
          onClick={() => {
            event({
              action: "download_app_click",
              category: "engagement",
              label: "Download App Button - Header",
              value: 1,
            });
          }}
        >
          {t("downloadApp")}
        </ButtonLink>

        <ButtonLink
          href={`/${otherLocale}${targetPath}`}
          className={styles.action}
          variant="primaryLink"
        >
          {switchLabel}
        </ButtonLink>
      </div>
    </header>
  );
};

export default DesktopHeader;
